export const FETCH_ERROR = 'FETCH_ERROR';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
